module.exports = __webpack_public_path__ + "fontawesome-webfont.a130857edacbb0559ef6.woff";


//////////////////
// WEBPACK FOOTER
// D:/Works/Safetyminder/Safetyminder/Admin/src/assets/fonts/fontawesome-webfont.woff?v=4.6.3
// module id = ../../../../../src/assets/fonts/fontawesome-webfont.woff?v=4.6.3
// module chunks = styles